import React from "react";

// @mui component
import Box from "../components/mui/Box";

// container
import ForgotPasswordContainer from "../containers/ForgotPasswordContainer";

function ForgotPassword() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // background: "linear-gradient(135deg, #FFD3A5 0%, #FD6585 100%)", // Adjust gradient colors as needed
        background:
          "linear-gradient(180deg, rgba(243, 192, 8, 0.20) 0%, rgba(232, 84, 28, 0.20) 100%), #F9F9F9;",
      }}
    >
      <ForgotPasswordContainer />
    </Box>
  );
}

export default ForgotPassword;
